<template>
	<div class="ccls-details-modal-list">
		<div class="ccls-details-modal-list__title" v-if="hasCompanies">
			Companies
		</div>
		<div class="ccls-details-modal-list__list" v-if="hasCompanies">
			<div
				class="ccls-details-modal-list__list-item"
				v-for="(item, key) in cclsData.companies"
				:key="`company_${key}`"
			>
				{{ item.text }}
			</div>
		</div>
		<div class="ccls-details-modal-list__title" v-if="hasLocations">
			Sub Locations
		</div>
		<div class="ccls-details-modal-list__list" v-if="hasLocations">
			<div
				class="ccls-details-modal-list__list-item"
				v-for="(item, key) in cclsData.locations"
				:key="`location_${key}`"
			>
				{{ item.text }}
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
export default {
	name: 'CCLsDetailsModalList',
	props: {
		cclsData: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		hasCompanies() {
			return _.get(this, 'cclsData.companies', []).length > 0;
		},
		hasLocations() {
			return _.get(this, 'cclsData.locations', []).length > 0;
		}
	}
};
</script>

<style lang="scss" scoped>
.ccls-details-modal-list {
	max-height: 250px;
	@include scrollbar;
	overflow-y: auto;

	&__title {
		@include heading('md');
		margin-bottom: $gutter-lg;
	}

	&__list {
		@include body-text('regular');

		&:not(:last-child) {
			margin-bottom: $gutter-xl;
		}
	}

	&__list-item {
		@include body-text('regular');

		&:not(:last-child) {
			margin-bottom: $gutter-md;
		}
	}

	&__no-result {
		&:not(:last-child) {
			margin-bottom: $gutter-xl;
		}
	}
}
</style>
